import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AdditionalOrderColumn,
  PayoutDisputeStatusDetails,
  FilterDefinitionType,
  OrdersTab,
} from 'enums';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

type Props = {
  tab?: OrdersTab;
  additionalFilters?: FilterDefinition<OrderFilters>[];
  additionalColumns?: AdditionalOrderColumn[];
};

export const DisputeOrders: React.FC<Props> = ({
  tab = OrdersTab.Dispute,
  additionalColumns: propsColumns = [],
  additionalFilters: propsFilters = [],
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.resolve',
  });

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      ...propsFilters,
      {
        label: t('title_dispute'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: Object.values(PayoutDisputeStatusDetails),
        getDisplayName: (value: PayoutDisputeStatusDetails) =>
          orderUtils.getPayoutStatusDetailsLabel(value),
      },
    ],
    [propsFilters, t],
  );

  return (
    <ManageOrdersList
      tab={tab}
      additionalColumns={[
        ...propsColumns,
        AdditionalOrderColumn.CustomerPayment,
        AdditionalOrderColumn.TraderCard,
        AdditionalOrderColumn.TraderPayment,
        AdditionalOrderColumn.Dispute,
        AdditionalOrderColumn.Validation,
      ]}
      additionalFilters={additionalFilters}
    />
  );
};
